import { ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { NavigationTrackerButtonLink } from '../../NavigationTracker/NavigationTrackerButtonLink';

interface LoginMenuSectionProps {
    isLoggedIn: boolean;
    firstName: string;
    lastName: string;
    loginUrl: string;
    registerUrl: string;
    className?: string;
    isPhysicalStoreAdmin: boolean;
    isInPhysicalStoreMode: boolean;
    onPhysicalStoreChange: () => void;
    id?: string;
}

export const LoginMenuSection = (props: LoginMenuSectionProps) => {
    const getAnonymousUserContent = () => (
        <NavigationTrackerButtonLink size={ButtonSize.Medium} className="LoginMenu__Button" href={props.loginUrl} rel="nofollow noopener" source="ActionMenu">
            {getTranslation(keys['actionMenu.logIn'])}
        </NavigationTrackerButtonLink>
    );

    const switchClassesPhysicalStore = classNames(
        'LoginMenu__PhysicalStoreModeSwitch',
        props.isInPhysicalStoreMode && 'LoginMenu__PhysicalStoreModeSwitch--Active'
    );

    const getLoggedInUserContent = () => (
        <>
            <span className="LoginMenu__UserName">
                {props.firstName} {props.lastName}
            </span>

            {props.isPhysicalStoreAdmin && (
                <div className="LoginMenu__PhysicalStoreMode">
                    <label key="label" htmlFor={`physicalStoreMode-${props.id}`}>
                        <span>{getTranslation(keys['navigation.physicalStoreMode'])}</span>
                    </label>
                    <div className={switchClassesPhysicalStore} onClick={props.onPhysicalStoreChange} />
                    <input
                        id={`physicalStoreMode-${props.id}`}
                        key="input"
                        type="checkbox"
                        checked={props.isInPhysicalStoreMode}
                        onChange={props.onPhysicalStoreChange}
                    />
                </div>
            )}

            {!props.isPhysicalStoreAdmin && <div className="LoginMenu__Divider" />}
        </>
    );

    return (
        <div className={classNames('LoginMenu', props.className)}>
            {!props.isLoggedIn && getAnonymousUserContent()}
            {props.isLoggedIn && getLoggedInUserContent()}
        </div>
    );
};
